import { type FC, useState } from "react";

import { DEPLOYMENT_EVENT_CHANNEL } from "@recobra/core";
import { m } from "@recobra/i18n/messages";
import { DeploymentAnnouncementSchema } from "@recobra/schemas/deployment";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@recobra/ui/alert-dialog";

import { useDocumentEvents } from "../documents";

const runningDeploymentId = globalThis.document?.querySelector<HTMLMetaElement>(
  'meta[name="deployment-id"]',
)?.content;

/** Blocks the app with a reload prompt once a newer deployment of the stage is announced. */
export const DeploymentRefreshDialog: FC = () => {
  const [isOutdated, setIsOutdated] = useState(false);

  useDocumentEvents(DEPLOYMENT_EVENT_CHANNEL, (payload) => {
    const announcement = DeploymentAnnouncementSchema.safeParse(payload);
    if (announcement.success && announcement.data.deploymentId !== runningDeploymentId) {
      setIsOutdated(true);
    }
  });

  return (
    <AlertDialog open={isOutdated}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.app_new_version_title()}</AlertDialogTitle>
          <AlertDialogDescription>{m.app_new_version_description()}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => window.location.reload()}>
            {m.app_reload_page()}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
